import React from "react";
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import './medicalservices.styles.css';
const MedicalServices = () => {
  return (
    <>
      <div className="header2">
        <Header></Header>
        <section class="inner-banner services-banner">
          <div class="container h-100">
            <div class="inner-caption">
              <h2>Home Medical Services<br></br>
                <p className="mb-0 text-center">( Coming Soon )</p>
              </h2>
            </div>
          </div>
        </section>
        <div className="container">
          <div class="services-listing-wrapper">
            <ul>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/ambulance-service.png")} alt="Ambulance Service" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Ambulance Service</h2>
                    <p>Dawa Asaan provides fully equipped ambulance services for transport of patient from their home to hospital and back.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/phyiscio.png")} alt="phyiscio" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Physiotherapy</h2>
                    <p>Our skilled team of home physiotherapist treats a variety of conditions and work with patients of all ages at home for rehabilitation.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/cardic-service.png")} alt="cardic-service" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Cardiac Function Testing</h2>
                    <p>To determine whether the heart of a patient is functioning normally, our expert cardiology healthcare team performs diagnostic procedures at home.</p>
                  </a>
                </div>
              </li>
              {/* <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/health-service.png")} alt="health-service" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Online Pharmacy</h2>
                    <p>We deliver authentic and quality medicines and medical equipments delivered at your doorstep.</p>
                  </a>
                </div>
              </li> */}
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/nursing-icon.png")} alt="nursing-icon" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Home Nursing Care</h2>
                    <p>Qualified nursing staff and nursing attendants provide medical treatment and compassionate care at home.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/imaging-services.png")} alt="imaging-services" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Home Imaging Services</h2>
                    <p>mediQ provides imaging services at home including digital X-ray, ultrasound, echo-cardiography and color doppler ultrasound</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/eldery-icon.png")} alt="eldery-icon" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Elderly Care</h2>
                    <p>We take care of the elderly and others with physical and/or mental impairments to meet their long term care needs.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/dilaysis-icon.png")} alt="dilaysis-icon" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Home Hemodialysis</h2>
                    <p>With new, state of the machines and our expert tem of dialysis technicians and nephrologists we provide home hemo-dialysis services.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/online-lab.png")} alt="online-lab" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Home Laboratory Collection</h2>
                    <p>Our trained laboratory technicians collect laboratory samples from you home at time of your convenience for testing.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/child-health.png")} alt="child-health" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Maternal & Child Health</h2>
                    <p>Our team of obstetricians and pediatricians provides consultation to women during pregnancy and the postnatal period as well ensures proper care of children.</p>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <section class="sectionspace80 bookingsection">
          <div class="container">
            <div class="heading-title">
              <h2>Download Dawa Asaan App Now!</h2>
            </div>
            <div class="row pt-md-4 align-items-center justify-content-center  mx-0 mx-md-row px-2 px-md-0">
              <div class="col-12 col-md-4">
                <figure class="mobileapp_img_holder position-relative mx-auto mb-3 mb-md-2">
                  <img class="mobileapp_img img-fluid" src={require("../../assets/images/mobile-img-3.png")} alt="mobile app Dawa Asaan" />
                </figure>
              </div>
              <div class="col-12 col-md-5 pb-4 text_center_mobile">
                <p class="mb-3">Avail best quality health care services on click of a button.</p>
                <a href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507" target="_blank" class="mr-2"><img src={require("../../assets/images/ios.png")} /></a>
                <a href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan" target="_blank" class="mr-2"><img src={require("../../assets/images/google.png")} /></a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer></Footer>
    </>
  )
}
export default MedicalServices;